require("./lastAccess.scss");

// @vendors
const React = require("react");
const { connect } = require("react-redux");
const { Component } = require("react");
const { Link } = require('react-router-dom');
const PropTypes = require("prop-types");
const DateHelper = require('utilities/dateHelper');

// @core
const { formatText } = require("core/i18n").i18n;

// @components
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");

// @commons
const { LoadingDots } = require("commonsComponents/loadingDots");

class LastAccess extends Component {
    constructor(props) {
        super(props);
        this.getContents = this.getContents.bind(this);
        this.renderText = this.renderText.bind(this);
    }

    renderText() {
        const { lastAccess } = this.props;
        const title = formatText("common-lastAccess");

        return [
            <i key="icon" className="icon-tiempo last-access__icon" />,
            <span
                key="title"
                className="last-access__link__title"
            >{`${title}: `}</span>,
            DateHelper.getOnlyDateFormatted(lastAccess)
        ];
    }

    getContents() {
        const { isLoading, showSessionsAndDevices } = this.props;

        if (isLoading) {
            return <LoadingDots inline color="light" size="small" />;
        }

        return (
            <div className="last-access__wrapper">
                {showSessionsAndDevices ? (
                    <Link to="/myprofile/devices" className="last-access__link">
                        {this.renderText()}
                    </Link>
                ) : (
                    this.renderText()
                )}
            </div>
        );
    }

    render() {
        const target = this.getContents();
        return (
            <div className="last-access">
                <OKTooltip
                    content="common-lastAccessTooltip"
                    modifier="dark-bg"
                    offset={[-15, 0]}
                    placement="left"
                    target={target}
                />
            </div>
        );
    }
}

LastAccess.propTypes = {
    isLoading: PropTypes.bool,
    lastAccess: PropTypes.string,
    originCountry: PropTypes.string,
    showSessionsAndDevices: PropTypes.bool
};

LastAccess.defaultProps = {
    isLoading: false,
    lastAccess: new Date().toISOString()
};

module.exports = connect(state => ({
    originCountry: state.profile.get("originCountry"),
    showSessionsAndDevices: state.flagBasedFeatures.get("sec-sessions")
}))(LastAccess);
